import { DownloadIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../components/atoms/button/button';

const ExportPDFButton = ({ onClick }: { readonly onClick: () => void }) => {
  const { t } = useTranslation();

  return (
    <Button appearance="secondary" icon={DownloadIcon} onClick={onClick} size="sm">
      {t('report.blocks.exportPDFButton.buttonText')}
    </Button>
  );
};

export { ExportPDFButton };
